import { Button, Col, Drawer, Form, message, Row, Select, Space } from "antd";
import { useContext, useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import Moment from "react-moment";
import { AuthContext } from "../../../contexts/AuthContext";
import confirmBooking from "../../../services/confirmBooking";
import fetchAllUsers from "../../../services/fetchAllUsers";
const { Option } = Select;

export default function ConfirmPanel({
  isVisible,
  selected,
  refetch,
  setVisible,
}: any) {
  const [form] = Form.useForm();
  const [users, setUsers] = useState<any>([]);

  const { user } = useContext(AuthContext);

  const isAdvisor = user?.role?.name === "Service Advisor" ? true : false;

  const onSubmit = async () => {
    let { assignedTo } = form.getFieldsValue();
    if (isAdvisor) {
      assignedTo = user?._id;
    }
    const data = {
      status: "Confirmed",
      name: selected?.customer_name,
      mobile: selected?.customer_mobile,
      is_confirmed: true,
      assignedTo,
    };
    const booking_id = selected._id;
    const response = await confirmBooking(data, booking_id);
    if (response.success) {
      message.success("Confirmed successfully");
    } else {
      message.error("Something went wrong");
    }
    setVisible(false);
    await refetch();
  };

  const hideModal = () => {
    setVisible(false);
  };

  const handleFetchUsers = async () => {
    const response = await fetchAllUsers();
    const filtered = response?.payload.filter(
      (item: any) => item.role?.name === "Service Advisor"
    );
    setUsers(filtered);
  };

  const clearForm = async () => {
    form.resetFields();
  };

  const userOptions = users.map((user: any, index: number) => (
    <Option value={user?._id} key={index}>
      {user?.firstname} {user?.lastname}
    </Option>
  ));

  useEffect(() => {
    form.resetFields();
    handleFetchUsers();
  }, [selected]);

  return (
    <Drawer
      title={`CONFIRM BOOKING`}
      placement={"right"}
      width={800}
      onClose={() => setVisible(false)}
      visible={isVisible}
      closable={false}
      extra={
        <Space className="flex justify-center items-center">
          <Button
            type="default"
            color="#E50000"
            onClick={() => setVisible(false)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      <Form
        id="UpdateBooking"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
      >
        <div className="pb-4">
          <div className="flex text-black font-bold text-lg">
            VEHICLE: {selected?.title}
          </div>
          <div className="flex ">
            <span className="w-12">Date: </span>
            <Moment format="Do MMM, YYYY">{selected?.date}</Moment>
          </div>
          <div className="flex ">
            <span className="w-12">Time : </span>
            <Moment format="HH:mm A">{selected?.slottime?.starttime}</Moment>
            <div className="mx-2">-</div>
            <Moment format="HH:mm A">{selected?.slottime?.endtime}</Moment>
          </div>
        </div>
        <div className="">Booking No. {selected?.bookingno}</div>
        {isAdvisor ? null : (
          <Row gutter={[16, 0]}>
            <Col xs={{ span: 24 }} lg={{ span: 24 }}>
              <Form.Item
                name="assignedTo"
                label="Assign To"
                rules={[
                  {
                    required: true,
                    message: "Please select assignee",
                  },
                ]}
              >
                <Select placeholder="Assign To">{userOptions}</Select>
              </Form.Item>
            </Col>
          </Row>
        )}

        <div className="mt-4">
          <Form.Item>
            <Button danger type="primary" htmlType="submit">
              Confirm
            </Button>
            <Button htmlType="button" className="mx-2" onClick={clearForm}>
              Reset
            </Button>
            <Button htmlType="button" className="mx-2" onClick={hideModal}>
              Close
            </Button>
          </Form.Item>
        </div>
      </Form>
    </Drawer>
  );
}
